@let memberDataValue = memberData();
@let canManageTellentValue = canManageTellent();
@let memberNotInvitedValue = memberNotInvited();
@let memberAbilities = memberData()?.abilities || [];

@if (usersWithoutEmails()) {
  <rt-dialog-body variant="white" [class.no-footer]="memberNotInvitedValue">
    <div class="container">
      <div class="heading">
        <rt-heading variant="large heading">
          {{ 'tlc.members.edit_member.permission_access_tab.heading.title_v2' | translate }}
        </rt-heading>
        <span margin-bottom-small-x
          >{{ 'tlc.members.edit_member.permission_access_tab.heading.description_v2' | translate }}
        </span>
      </div>

      @if (memberNotInvitedValue) {
        <tlc-invite-member-without-access-box (inviteClick)="sendInvitation()" />

        @if (memberHasNoKiwiSeat()) {
          <rt-infobox
            type="information"
            iconName="info-outline"
            [isDismissible]="false"
            margin-top-small
          >
            <div class="infobox-content">
              <span class="heading">{{
                'tlc.members.edit_member.permission_access_tab.listed_only_infobox.title'
                  | translate
              }}</span>
              <span>{{
                'tlc.members.edit_member.permission_access_tab.listed_only_infobox.subtitle'
                  | translate
              }}</span>
            </div>
          </rt-infobox>
        }
      } @else {
        @if (loginMethod() === LoginMethod.Username) {
          <rt-infobox
            type="information"
            iconName="info-outline"
            [isDismissible]="false"
            [buttons]="changeLoginInfoboxButton()"
            margin-tb-small
          >
            <span class="heading">{{
              'tlc.members.edit_member.permission_access_tab.infobox.content' | translate
            }}</span>
          </rt-infobox>
        }

        <tlc-access-roles-table
          [recruiteeFormGroup]="seats.recruitee"
          [kiwiFormGroup]="seats.kiwi"
          [kiwiAdministratorRoleDisabled]="loginMethod() === LoginMethod.Username"
          margin-bottom-large
        />

        @if (memberAbilities.length === 0) {
          <div layout>
            <rt-button
              variant="plain"
              [disabled]="loginMethod() === LoginMethod.Username"
              (click)="openGiveAdminPermissionsDialog()"
            >
              <rt-icon prefix name="add" />
              <span>{{
                'tlc.members.edit_member.permission_access_tab.admin_permissions.give_admin_permissions'
                  | translate
              }}</span>
            </rt-button>
          </div>
        } @else {
          <div class="admin-permissions-container">
            <span class="heading">{{
              'tlc.members.edit_member.permission_access_tab.admin_permissions.heading' | translate
            }}</span>
            <span class="subheading">{{
              'tlc.members.edit_member.permission_access_tab.admin_permissions.subheading'
                | translate
            }}</span>
            <tlc-edit-member-permissions-box
              [abilities]="memberAbilities"
              [canManageTellent]="canManageTellentValue"
              [isOwner]="memberData()?.owner!"
              (actionClicked)="openGiveAdminPermissionsDialog()"
            />
          </div>
        }
      }
    </div>
  </rt-dialog-body>

  @if (!memberNotInvitedValue) {
    <rt-dialog-footer variant="white">
      <rt-button variant="plain" (click)="cancel()"
        >{{ 'tlc.common.cancel' | translate }}
      </rt-button>
      <rt-button [loading]="pending()" (click)="submit()" variant="primary"
        >{{ 'tlc.common.save' | translate }}
      </rt-button>
    </rt-dialog-footer>
  }
} @else {
  <!-- Part below is displayed for legacy settings without UWE -->
  <rt-dialog-body variant="white">
    <div class="container">
      <div class="heading">
        <rt-heading variant="large heading">
          {{ 'tlc.members.edit_member.permission_access_tab.heading.title' | translate }}
        </rt-heading>
        <span margin-bottom-small-x
          >{{ 'tlc.members.edit_member.permission_access_tab.heading.description' | translate }}
        </span>
      </div>

      <tlc-edit-member-permissions-box
        [abilities]="memberDataValue?.abilities || []"
        [canManageTellent]="canManageTellentValue"
        (actionClicked)="openGiveAdminPermissionsDialog()"
        margin-bottom-large
      />

      @if (seats) {
        <div class="heading">
          <rt-heading variant="large heading">
            {{ 'tlc.members.edit_member.permission_access_tab.access.heading.title' | translate }}
          </rt-heading>
          <span margin-bottom-small-x
            >{{
              'tlc.members.edit_member.permission_access_tab.access.heading.description' | translate
            }}
          </span>
        </div>
        <tlc-access-roles-table
          [recruiteeFormGroup]="seats.recruitee"
          [kiwiFormGroup]="seats.kiwi"
          [kiwiAdministratorRoleDisabled]="loginMethod() === LoginMethod.Username"
        />
      }
    </div>
  </rt-dialog-body>

  <rt-dialog-footer variant="white">
    <rt-button variant="plain" (click)="cancel()">{{ 'tlc.common.cancel' | translate }}</rt-button>
    <rt-button [loading]="pending()" (click)="submit()" variant="primary"
      >{{ 'tlc.common.save' | translate }}
    </rt-button>
  </rt-dialog-footer>
}
